import React, { useState } from 'react';
import { Input, Button, Modal, Spin } from 'antd';
import {
  StepBackwardOutlined, CaretLeftOutlined,
  CaretRightOutlined, StepForwardOutlined,
  PlusOutlined, EditOutlined, DeleteOutlined,
  SaveOutlined, CloseOutlined, SearchOutlined,
} from '@ant-design/icons';
import { useJobGradeForm } from './hooks/useJobGradeForm';
import './P9103Form.css';

const P9103Form: React.FC = () => {
  const {
    mode, loading, f903_01, f903_11, f903_91, f903_92, f903_93,
    setF90301, setF90311,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save, doDelete,
    quickSearch, recordPosition, recordCount,
  } = useJobGradeForm();

  const [searchKey, setSearchKey] = useState('');

  const isEditing = mode === 'add' || mode === 'edit';

  return (
    <Spin spinning={loading}>
      <div className="p9103-form">
        <h2>職等定義</h2>

        {/* Quick Search */}
        <div className="p9103-search-bar">
          <Input
            placeholder="輸入代號快速搜尋"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
            onPressEnter={() => quickSearch(searchKey)}
            style={{ width: 200 }}
            disabled={isEditing}
          />
          <Button
            icon={<SearchOutlined />}
            onClick={() => quickSearch(searchKey)}
            disabled={isEditing}
          >
            搜尋
          </Button>
          <span className="p9103-record-info">
            {recordPosition} / {recordCount}
          </span>
        </div>

        {/* Navigation */}
        <div className="p9103-nav-bar">
          <Button icon={<StepBackwardOutlined />} onClick={navFirst} disabled={isEditing}>首筆</Button>
          <Button icon={<CaretLeftOutlined />} onClick={navPrev} disabled={isEditing}>前筆</Button>
          <Button icon={<CaretRightOutlined />} onClick={navNext} disabled={isEditing}>次筆</Button>
          <Button icon={<StepForwardOutlined />} onClick={navLast} disabled={isEditing}>末筆</Button>
        </div>

        {/* Form Fields */}
        <div className="p9103-fields">
          <div className="p9103-field-row">
            <label>職等代號</label>
            <Input
              value={f903_01}
              onChange={(e) => setF90301(e.target.value)}
              maxLength={4}
              disabled={mode !== 'add'}
              style={{ width: 120 }}
            />
          </div>
          <div className="p9103-field-row">
            <label>職等名稱</label>
            <Input
              value={f903_11}
              onChange={(e) => setF90311(e.target.value)}
              maxLength={20}
              disabled={!isEditing}
              style={{ width: 240 }}
            />
          </div>

          {/* Audit fields (read-only) */}
          <div className="p9103-field-row">
            <label>建立者</label>
            <Input value={f903_91} disabled style={{ width: 120 }} />
          </div>
          <div className="p9103-field-row">
            <label>建立日期</label>
            <Input value={f903_92 ? f903_92.substring(0, 10) : ''} disabled style={{ width: 140 }} />
          </div>
          <div className="p9103-field-row">
            <label>修改者</label>
            <Input value={f903_93} disabled style={{ width: 120 }} />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="p9103-actions">
          {!isEditing ? (
            <>
              <Button type="primary" icon={<PlusOutlined />} onClick={startAdd}>新增</Button>
              <Button icon={<EditOutlined />} onClick={startEdit} disabled={recordCount === 0}>修改</Button>
              <Button
                danger
                icon={<DeleteOutlined />}
                disabled={recordCount === 0}
                onClick={() => {
                  Modal.confirm({
                    title: '確認刪除',
                    content: `確定要刪除職等 ${f903_01} 嗎？`,
                    onOk: doDelete,
                  });
                }}
              >
                刪除
              </Button>
            </>
          ) : (
            <>
              <Button type="primary" icon={<SaveOutlined />} onClick={save}>存檔</Button>
              <Button icon={<CloseOutlined />} onClick={cancel}>還原</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P9103Form;
